// extracted by mini-css-extract-plugin
module.exports = {"root":"_2R6yN","iconHolder":"_2Fbdm"};